export const roundPrice = (price: number) => Math.ceil(price * 100) / 100

export const toOptionalFixed = (num: number, digits: number) => {
  return Number.parseFloat(num.toFixed(digits))
}
